const urlhost = window.location.host;
const subDomain = urlhost.split('.')[1]+'.'+urlhost.split('.')[2]
const loopBackDomain = `https://product-stg.${subDomain}`
const Domain =  `https://product-stg.${subDomain}:5005`
const loopBackPort = 5002;

module.exports = {
    loopBackDomain,
    loopBackPort,
    Domain
}
